export default __webpack_public_path__ + "static/media/Animals_26.eda8fbf2.png";